export default __webpack_public_path__ + "static/media/ada.2113a699.png";